<template>
  <div id="public">
    <layout v-if="isReady"></layout>
  </div>
</template>

<script>
import Layout from './components/public/Layout'
import './assets/parsley-materialize.css'
import './assets/materialize.overrides.scss'
import './assets/main.scss'
import './parsley-hu'
import {get} from './api'
import db from './db'

import $ from 'jquery'
window.$ = $
window.jQuery = $
import initJsLibs from './init-js-libs'

export default {
  components: {
    Layout
  },
  data() {
    return {
      isReady: false
    }
  },
  methods: {
    initSkin() {
      get(`/public/ajax/view-configuration`, (viewConfig) => {
        db.set('viewConfig', viewConfig)
        if (viewConfig.skin) {
          require(`./assets/skins/${viewConfig.skin}.scss`)
        }
        this.isReady = true
        $('body').css('visibility', 'visible')
      })
    }
  },
  created() {
    db.set('user', null)
    this.initSkin()
  },
  ready() {
    initJsLibs()
  }
}

</script>

<style>
body {
  font-family: Helvetica, sans-serif;
  visibility: hidden;
  background-color: #eeeeee;
}
</style>



// WEBPACK FOOTER //
// PubApp.vue?9fb1baea